import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import Avatar from 'components/Avatar'
import Button from 'components/Button'
import StyledNotificationsPanelItem from './StyledNotificationPanelItem'
import { T, Time } from 'components/Translations'
import { consumeNotification, wink, like } from 'store/actions'

const memberUrl = (member, ...meta) => {
  if (!member.nickname) {
    window.rb?.error(`user without nickname ${JSON.stringify({ member, meta })}`)
  }
  return `/members/${member.nickname}`
}

const PT = ({ label, sender }) => (
  <T
    label={label}
    macros={{
      screenname: () => (
        <Link className="username" key={sender.nickname} to={memberUrl(sender, 'PT', label)}>
          {sender.screenName}
        </Link>
      ),
    }}
  />
)

const notificationsMap = {
  WINK_SENT: ({ sender, dispatch }) => ({
    text: <PT label="messages/userWinked" sender={sender} />,
    actionText: <T label="actions/winkBack" />,
    action: () => dispatch(wink(sender)),
  }),
  PROFILE_VISIT: ({ sender }) => ({
    text: <PT label="messages/userVisited" sender={sender} />,
    actionText: <T label="actions/goForIt" />,
    url: memberUrl(sender, 'PROFILE_VISIT'),
  }),
  ADDED_TO_FAVORITES: ({ sender, dispatch }) => ({
    text: <PT label="messages/userLiked" sender={sender} />,
    actionText: <T label="actions/likeBack" />,
    action: () => dispatch(like(sender, true)),
  }),
  FLIRT_REQUEST: ({ sender }) => ({
    text: <PT label="messages/userFlirted" sender={sender} />,
    actionText: <T label="actions/flirt" />,
    url: memberUrl(sender, 'FLIRT_REQUEST'),
  }),
  // 99 flirt_popup - offer ignored and logic done purely on FE
  FLIRT_POPUP: ({ sender }) => ({
    text: <PT label="messages/wantToFlirt|clean" sender={sender} />,
    actionText: <T label="actions/flirt" />,
    url: '/flirt',
  }),
}

const NotificationsPanelItem = ({ notification, dispatch }) => {
  const { timestamp, id, typeAlias, sender } = notification
  const { text, action, actionText, url } = notificationsMap[typeAlias]({ sender, dispatch })
  const linkProps = url ? { as: Link, to: url } : {}
  const onClick = () => {
    dispatch(consumeNotification(notification))
    action && action()
  }

  return (
    <StyledNotificationsPanelItem key={id}>
      <div className="body">
        <div className="avatar">
          <Link to={memberUrl(sender, 'avatar', notification)}>
            <Avatar size="compact" user={sender} source="notifications" />
          </Link>
        </div>

        <div className="info">
          <div className="text">{text}</div>
          <div className="timestamp">
            <Time timestamp={timestamp} />
          </div>
        </div>
      </div>

      <div className="action">
        <Button size="base" onClick={onClick} {...linkProps}>
          {actionText}
        </Button>
      </div>
    </StyledNotificationsPanelItem>
  )
}

export default connect()(NotificationsPanelItem)
